import { MapView } from './MapView';

export class SelectTablesView {
  size: number;
  maps: Array<MapView>;
  hasError: boolean;
  isMapsLoading: boolean;
  isLoading: boolean;
  tables: Array<MapView>;

  constructor(params: SelectTablesViewParams) {
    this.size = params.size;
    this.maps = params.maps;
    this.hasError = params.hasError;
    this.isMapsLoading = params.isMapsLoading;
    this.isLoading = params.isLoading;
    this.tables = params.tables;
  }
}

export type SelectTablesViewParams = {
  size: number;
  maps: Array<MapView>;
  hasError: boolean;
  isMapsLoading: boolean;
  isLoading: boolean;
  tables: Array<MapView>;
};
